import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from 'context/AuthContext.jsx';

/**
 * Everything except /login sits behind this.
 *
 * Signed-out visitors are sent to /login with the page they wanted recorded, so
 * signing in returns them there instead of dumping them on the overview. The old
 * page had nowhere to record that, because there were no URLs.
 */
export default function ProtectedRoute({ children }) {
  const { isSignedIn } = useAuth();
  const location = useLocation();

  if (!isSignedIn) return <Navigate to="/login" replace state={{ from: location }} />;
  return children;
}
